<template>
  <div class="app-container">
    <div class="table-box">
      <el-form
        :model="queryParams"
        ref="queryForm"
        size="small"
        :inline="true"
        v-show="showSearch"
        label-width="100px"
      >
        <el-form-item label="淤地坝名称" prop="ydbName">
          <el-input
            v-model="queryParams.ydbName"
            placeholder="请输入淤地坝名称"
            clearable
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="行政区划" prop="address">
          <el-input
            v-model="queryParams.address"
            placeholder="请输入行政区划"
            clearable
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="问题" prop="issue">
          <el-select
            v-model="queryParams.issue"
            placeholder="请选择问题"
            clearable
          >
            <el-option
              v-for="dict in patrol_issue"
              :key="dict.value"
              :label="dict.label"
              :value="dict.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="issue">
          <el-select
            v-model="queryParams.status"
            placeholder="请选择状态"
            clearable
          >
            <el-option
              v-for="(status, index) in issueStatusOption"
              :key="index"
              :label="status.label"
              :value="status.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            size="mini"
            @click="handleQuery"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
            >重置</el-button
          >
        </el-form-item>
      </el-form>

      <el-table
        v-loading="loading"
        :data="patrolIssueRecordList"
        max-height="680"
      >
        <el-table-column label="序号" align="center" prop="id" />
        <el-table-column label="淤地坝名称" align="center" prop="ydbName" />
        <el-table-column label="行政区划" align="center" prop="address" />
        <el-table-column label="巡检人" align="center" prop="patrolUser" />
        <el-table-column label="巡检时间" align="center" prop="createTime">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="问题" align="center" prop="issue">
          <template slot-scope="scope">
            <div v-for="dict in patrol_issue" :key="dict.value">
              <span v-if="dict.value == scope.row.issue">{{ dict.label }}</span>
            </div>
            <!-- <dict-tag
            :options="patrol_issue"
            :value="scope.row.issue"
          /> -->
          </template>
        </el-table-column>
        <el-table-column label="问题附件" align="center" prop="issueUrl">
          <template slot-scope="scope">
            <media-slot :issueUrlStr="scope.row.issueUrl"></media-slot>
          </template>
          <!-- <template slot-scope="scope" v-if="scope.row.issueUrl">
          <div
            v-for="(url, index) in scope.row.issueUrl.split(',')"
            :key="index"
          >
            <el-link
              v-show="url.split('/') && url.split('/').length > 0"
              :href="url"
              :underline="false"
              target="_blank"
              >{{ url.split("/").reverse()[0] }}</el-link
            >
          </div>
        </template> -->
        </el-table-column>
        <!-- 核查文件 -->
        <el-table-column label="核查意见" align="center" prop="opinion" />
        <el-table-column label="核实附件" align="center" prop="opinionUrl">
          <template slot-scope="scope" v-if="scope.row.opinionUrl">
            <div
              v-for="(url, index) in scope.row.opinionUrl.split(',')"
              :key="index"
            >
              <el-link
                v-show="url.split('/') && url.split('/').length > 0"
                :href="url"
                :underline="false"
                target="_blank"
                >{{ url.split("/").reverse()[0] }}</el-link
              >
            </div>
          </template>
        </el-table-column>
        <!-- 验收文件 -->
        <el-table-column label="验收意见" align="center" prop="solve" />
        <el-table-column label="验收附件" align="center" prop="solveUrl">
          <template slot-scope="scope" v-if="scope.row.solveUrl">
            <div
              v-for="(url, index) in scope.row.solveUrl.split(',')"
              :key="index"
            >
              <el-link
                v-show="url.split('/') && url.split('/').length > 0"
                :href="url"
                :underline="false"
                target="_blank"
                >{{ url.split("/").reverse()[0] }}</el-link
              >
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="问题类型" align="center" prop="issueType">
        <template slot-scope="scope">
          <dict-tag
            :options="dict.type.issue_type"
            :value="scope.row.issueType"
          />
        </template>
      </el-table-column> -->
        <el-table-column label="状态" align="center" prop="status">
          <template slot-scope="scope">
            <span v-for="dict in issue_status" :key="dict.value">
              <el-button
                v-if="dict.value == scope.row.status"
                :type="dict.type"
                plain
                >{{ dict.label }}</el-button
              >
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status === '3'"
              size="small"
              type="primary"
              @click="handleSlove(scope.row)"
              >处理</el-button
            >
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 添加或修改巡检问题对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="130px">
        <el-form-item label="验收意见" prop="solve">
          <textarea cols="40" rows="10" v-model="form.solve"></textarea>
        </el-form-item>
        <el-form-item label="附件上传" prop="solveUrl">
          <file-upload
            :uploadFileUrl="uploadFileUrl"
            :fileType="['doc', 'xls', 'ppt', 'txt', 'pdf', 'png', 'jpg']"
            :fileSize="100"
            v-model="form.solveUrl"
          ></file-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="submitForm">确定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MediaSlot from "@/components/mediaSlot/index.vue";
import FileUpload from "@/components/FileUpload/index.vue";
import Axios from "axios";

export default {
  name: "PatrolIssueRecord",
  components: { MediaSlot, FileUpload },
  data() {
    return {
      issue_status: [
        {
          value: 1,
          label: "待确认",
          type: "primary",
        },
        {
          value: 2,
          label: "已销毁",
          type: "info",
        },
        {
          value: 3,
          label: "正在解决",
          type: "danger",
        },
        {
          value: 4,
          label: "已解决",
          type: "success",
        },
      ],
      issue_type: [
        {
          value: 1,
          label: "新增问题",
        },
        {
          value: 2,
          label: "重复问题",
        },
      ],
      patrol_issue: [
        {
          value: 1,
          label: "卧管、竖井",
        },
        {
          value: 2,
          label: "涵洞",
        },
        {
          value: 3,
          label: "溢洪道",
        },
        {
          value: 4,
          label: "坝体",
        },
        {
          value: 5,
          label: "上坝道路",
        },
      ],
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 巡检问题表格数据
      patrolIssueRecordList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        address: null,
        issue: null,
        status: "3",
        ydbName: "",
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        solve: [
          { required: true, message: "验收意见不能为空", trigger: "blur" },
        ],
      },
      uploadFileUrl: "/hzyApi/hwDocking/uploadFile",
      issueStatusOption: [
        {
          label: "全部",
          value: null,
        },
        {
          label: "正在解决",
          value: "3",
        },
        {
          label: "已解决",
          value: "4",
        },
      ],
      headers: {
        "Access-Token": this.$store.state.token,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询巡检问题列表 */
    getList() {
      this.loading = true;
      this.queryParams.deptId = this.$store.state.regionCode;
      Axios.get("/hzyApi/hwDocking/getIssueList", {
        params: this.queryParams,
        headers: this.headers,
      }).then((res) => {
        // console.log("res-----", res)
        if (res.data.code == 200) {
          this.patrolIssueRecordList = res.data.rows;
          this.total = res.data.total;
        }
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        patrolId: null,
        issue: null,
        issueUrl: null,
        status: null,
        opinion: null,
        remark: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },

    /** 提交按钮 */
    submitForm() {
      // if (!this.form.solve || this.form.solve.length < 1) {
      //   this.$modal.msg("请先完善验收意见！");
      //   return;
      // }
      // 将状态设置为已解决
      this.form.status = "4";
      // console.log("this.$store.state=", this.$store.state)
      this.form.username = this.$store.state.name;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          Axios.post("/hzyApi/hwDocking/issueOperate", this.form, {
            params: this.form,
            headers: this.headers,
          }).then((res) => {
            // console.log("updatePatrolIssueRecord---response", res);
            if (res.data.code == 200) {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            }
          });
        }
      });
    },

    /** 解决按钮操作 */
    handleSlove(row) {
      this.reset();
      this.open = true;
      this.title = "处理巡检问题";
      this.form.id = row.id;
      this.form.issue = row.issue;
    },
  },
};
</script>

<style scoped>
.table-box {
  height: 90vh;
  overflow: hidden;
}
</style>
